// MovieDetail.jsx
import React from 'react';
import "../MovieDetail.css" // Assicurati di avere questo file CSS

const MovieDetail = ({ selectedMovie }) => {
    return (
        <div className="movie-details">
            <h2>{selectedMovie.Title}</h2>
            <p><strong>Year:</strong> {selectedMovie.Year}</p>
            <p><strong>Rated:</strong> {selectedMovie.Rated}</p>
            <p><strong>Released:</strong> {selectedMovie.Released}</p>
            <p><strong>Runtime:</strong> {selectedMovie.Runtime}</p>
            <p><strong>Genre:</strong> {selectedMovie.Genre}</p>
            <p><strong>Director:</strong> {selectedMovie.Director}</p>
            <p><strong>Actors:</strong> {selectedMovie.Actors}</p>
            <p><strong>Plot:</strong> {selectedMovie.Plot}</p>
            <p><strong>Language:</strong> {selectedMovie.Language}</p>
            <p><strong>Country:</strong> {selectedMovie.Country}</p>
            <p><strong>Awards:</strong> {selectedMovie.Awards}</p>
            <button onClick={() => window.location.reload()}>Close</button>
        </div>
    );
};

export default MovieDetail;
